import { RefObject } from 'react';
import useMediaQuery from 'src/lib/Hooks/useMediaQuery';

type FindContractorBackgroundType = {
  bgImage: {
    desktop: string;
    mobile: string;
  };
  containerRef: RefObject<HTMLDivElement>;
  children: JSX.Element | JSX.Element[];
};

const FindContractorBackground = ({
  bgImage,
  containerRef,
  children,
}: FindContractorBackgroundType) => {
  const isMobile = !useMediaQuery('md');
  const gradientWithImage = isMobile
    ? `linear-gradient(transparent -100%,#014464 22%), url("${bgImage.mobile}")`
    : `linear-gradient(transparent -100%,#014464 35%), url("${bgImage.desktop}")`;

  return (
    <div
      className="overflow-hidden relative h-auto w-full bg-no-repeat bg-contain px-18 py-56 flex flex-col flex-grow"
      style={{
        backgroundImage: gradientWithImage,
        backgroundPosition: 'top center',
      }}
      ref={containerRef}
    >
      {children}
    </div>
  );
};

export default FindContractorBackground;
